module.exports = __webpack_public_path__ + "img/anychenk_logo@2x.d7685b28.png";